import { HrmActions } from '../../pages/components/hrm_actions'

export const adminNewsColumns = ({ onSelectAction }) => {
  return [
    {
      Header: 'Sr. No.',
      accessor: 'idd', // Assuming you set 'idd' correctly in the data
      Cell: ({ row }) => {
        return row.original.idd // Return the idd value
      }
    },
    {
      Header: 'Title',
      accessor: row => {
        return row?.title || 'N/A'
      }
    },
    // {
    //   Header: 'Description',
    //   accessor: row => {
    //     return (
    //       <div className='text-left'>
    //         <div className='' dangerouslySetInnerHTML={{__html:  row?.description}}></div>
    //       </div>
    //     )
    //   }
    // },
    {
      Header: 'Short Description',
      accessor: row => {
        return row?.short_description || ''
      }
    },
    {
      Header: 'Description',
      accessor: (row) => {
        return (
          <><HrmActions
          onSelectAction={onSelectAction}
          row={row}
          view={ true }
          datas={row?.description}
        /></>
        );
      },
    },
    
    {
      Header: 'Image',
      accessor: row => {
        return (
          <div className='text-left'>
            <img src={row?.image} alt={`image-${row.id}`} />
          </div>
        )
      }
    },
    {
      Header: 'Logo',
      accessor: row => {
        return (
          <div className='text-left'>
            <img src={row?.logo} alt={`logo-${row.id}`} />
          </div>
        )
      }
    },
    {
      Header: 'Actions',
      accessor: row => {
        return (
          <div className='text-left'>
            <HrmActions
              onSelectAction={onSelectAction}
              row={row}
              isDefault={true}
            />
          </div>
        )
      }
    }
  ]
}
